import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const StatisticsPageAnalyticsBanner = lazy(() => import('./StatisticsPageAnalyticsBanner'))

class StatisticsPageAnalyticsBannerComponent extends ReactWebComponent {
	override render() {
		return (
			<AppProviders>
				<StatisticsPageAnalyticsBanner />
			</AppProviders>
		)
	}
}

customElements.define('statistics-page-analytics-banner', StatisticsPageAnalyticsBannerComponent)
